<template>
  <div>
    {{ getRevisionText(revision) }}
  </div>
</template>

<script>
export default {
  name: 'RevisionType',
  props: {
    revision: {
      type: String,
      required: true,
    },
  },
  methods: {
    getRevisionColor(status) {
      let color = 'default'

      switch (status) {
        case 'ADD':
          color = '#fff'
          break

        case 'MOD':
          color = '#fff'
          break

        case 'DEL':
          color = '#fff'
          break

        default:
          color = 'default'
      }

      return color
    },

    getRevisionText(status) {
      let text = '-'

      switch (status) {
        case 'ADD':
          text = 'Vytvořeno'
          break

        case 'MOD':
          text = 'Upraveno'
          break

        case 'DEL':
          text = 'Smazáno'
          break

        default:
          text = 'default'
      }

      return text
    },
  },
}
</script>
